export class Informacion {
    arreglo: any = [];
    tipo: string;

    constructor(arreglo: any, tipo: string) {
        this.arreglo = arreglo;
        this.tipo = tipo;
    }
}
